module.exports = __webpack_public_path__ + "img/construction-worker.161576a7.jpg";